import React from 'react';
import './About.css';

/* Only photos Yaya picked; six at most */
const PHOTOS = [
  { src: '/images/about-train.jpg', alt: 'Reading on a train through the hills', caption: '48 hr train ride' },
  { src: '/images/about-skyline-portrait.jpg', alt: 'Yaya with the San Francisco skyline at night', caption: 'sf rooftops!' },
  { src: '/images/about-tulips.jpg', alt: 'A bunch of tulips on the sidewalk', caption: 'my favorite flower' },
  { src: '/images/about-coast-trees.jpg', alt: 'Cypress trees above the ocean', caption: 'nature' },
];

/* A few photos don't fill the rail, so each half of the loop repeats
   the set until it is wider than the column (240px + 8px gap each) */
const HALF = Array.from(
  { length: Math.ceil(1200 / (PHOTOS.length * 248)) },
  () => PHOTOS
).flat();

const EXPERIENCE = [
  { org: 'Spira.AI', role: 'Product Design Intern', date: 'Fall 2026' },
  { org: 'Zovu', role: 'UI/UX Designer', date: 'Fall 2026' },
  { org: 'Adobe', role: 'Campus Leader', date: 'Fall 2026' },
  { org: 'Omnigence.ai', role: 'UI/UX Designer', date: 'Spring 2026' },
];

export default function About() {
  return (
    <section className="about-page" aria-label="About">
      <h1 className="about-title">Hi, I&apos;m Yaya!</h1>

      {/* Slow photo rail: the set twice over, so sliding it by exactly
          half loops without a seam */}
      <div className="about-rail">
        <div className="about-rail-track">
          {[...HALF, ...HALF].map((photo, i) => (
            <figure
              key={`${photo.src}-${i}`}
              className="about-rail-item"
              aria-hidden={i >= PHOTOS.length || undefined}
            >
              <img src={photo.src} alt={i < PHOTOS.length ? photo.alt : ''} draggable={false} />
              <figcaption>{photo.caption}</figcaption>
            </figure>
          ))}
        </div>
      </div>

      <div className="about-body">
        <div className="about-prose">
          <p className="about-meta">San Francisco · B.A. Art, California College of the Arts</p>
          <p>
            I&apos;m a product designer interested in how technology can feel
            more thoughtful, intuitive, and human. Hospitality taught me to
            notice the small moments: where people hesitate, need help, or
            feel cared for.
          </p>
          <p>
            I&apos;m drawn to 0→1 products, where I can move between research,
            design, and code to turn an early idea into something real.
          </p>
          <p>
            Outside of design: vibe coding, practicing golf and piano, and
            cooking something unnecessarily elaborate.
          </p>
        </div>
      </div>

      <section className="about-experience" aria-labelledby="about-experience-heading">
        <p className="about-label" id="about-experience-heading">Experience</p>
        <ul className="about-experience-list">
          {EXPERIENCE.map((item) => (
            <li key={`${item.org}-${item.date}`} className="about-experience-row">
              <span>
                <span className="about-experience-org">{item.org}</span>
                <span className="about-experience-role"> · {item.role}</span>
              </span>
              <span className="about-experience-date">{item.date}</span>
            </li>
          ))}
        </ul>
      </section>
    </section>
  );
}
